import { useFetch } from 'utils/sdk';

interface OverallResponseChartDataResultsItem {
  group_field_type: string;
  group_field_value: string;
  group_results: {
    x: string | number | Date | null | undefined;
    y: number;
  };
}

export interface OverallResponseChartDataResponse {
  is_suppressed: boolean,
  results: OverallResponseChartDataResultsItem[]
}

export interface ChartFilterProps {
  gender: string;
  ethnicity: string;
  grade: string;
  unit: string;
  state: string;
  is_low_income: string;
  is_on_individualized_education_plan: string;
  english_learner_status: string;
  standard_code: string;
}

export const useOverallResponseChartData = ({
  option,
  filters
}: {
  option: string;
  filters: ChartFilterProps;
}) =>
  useFetch<OverallResponseChartDataResponse>(
    `/api/v1/tags/research-portal/overall-response-chart/`,
    { option: option, ...filters }
  );

export interface SubmissionsVolumeChartDataResultsItem {
  group_field_type: string;
  group_field_value: string;
  submission_volume: number;
}

export interface SubmissionsVolumeChartDataResponse {
  is_suppressed: boolean;
  results: SubmissionsVolumeChartDataResultsItem[];
}

export interface MisconceptionsCoOccurrenceChartDataResponse {
  is_suppressed: boolean;
  results: Array<Array<number>>;
}

export const useSubmissionsVolumeChartData = ({
  option,
  filters
}: {
  option: string;
  filters: ChartFilterProps;
}) =>
  useFetch<SubmissionsVolumeChartDataResponse>(
    `/api/v1/tags/research-portal/submission-volume-chart/`,
    { option: option, ...filters }
  );

export interface MisconceptionsChartDataResultItem {
  misconception_name: string;
  occurence_count: number;
}

export interface MisconceptionsChartDataResponse {
  is_suppressed: boolean;
  results: MisconceptionsChartDataResultItem[];
}

export const useMisconceptionsChartData = ({
  filters
}: {
  filters: ChartFilterProps;
}) =>
  useFetch<MisconceptionsChartDataResponse>(
    `/api/v1/tags/research-portal/misconceptions-chart/`,
    {
      ...filters
    }
  );

export const useMisconceptionsCoOccurrenceChartData = ({
  filters
}: {
  filters: ChartFilterProps;
}) =>
  useFetch<MisconceptionsCoOccurrenceChartDataResponse>(
    `/api/v1/tags/research-portal/misconceptions-co-occurrence-chart/`,
    {
      ...filters
    }
  );
